import React, {Component, Suspense, lazy} from 'react';
import {useLocation} from 'react-router-dom';

class PageLoadBoundary extends Component {
    state = {failed:false};
    static getDerivedStateFromError() { return {failed:true}; }
    componentDidUpdate(previous) {
        if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({failed:false});
    }
    render() {
        if (this.state.failed) return <section role="alert" className="rounded border border-admin-line bg-admin-surface p-6 text-admin-text">
            <h1 className="mb-2 text-lg">Не удалось открыть раздел</h1>
            <p className="mb-4">Проверьте подключение и обновите страницу, чтобы загрузить актуальную версию админки.</p>
            <button type="button" className="entity-primary" onClick={()=>window.location.reload()}>Обновить страницу</button>
        </section>;
        return this.props.children;
    }
}

// Call once at module scope so React keeps page identity and editor state.
export default function lazyPage(load) {
    const Page = lazy(load);
    return function DeferredPage(props) {
        const {pathname,search} = useLocation();
        return <PageLoadBoundary resetKey={pathname+search}>
            <Suspense fallback={<div role="status" aria-live="polite" className="p-6 text-admin-muted">Загрузка раздела…</div>}>
                <Page {...props}/>
            </Suspense>
        </PageLoadBoundary>;
    };
}
